/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { LineItem } from './LineItem';
import type { MatchedBy } from './MatchedBy';
import type { ProductShort } from './ProductShort';

export type ProductLineItemMatch = {
    id: number;
    lineItem: LineItem;
    matchedProduct?: ProductShort;
    matchedBy?: MatchedBy;
    matchedByIdentities?: Array<MatchedBy>;
    matchScore?: number;
    quantity?: number;
    ocrScore: number;
    status: ProductLineItemMatch.status;
    isEditable: boolean;
    isDeletable: boolean;
    isMarkedForDeletion?: boolean;
    createdAt?: string;
    collectorId?: string;
    snapId?: number;
    retailer?: string;
    isTransactionCreated?: boolean;
    hasConflict?: boolean;
};

export namespace ProductLineItemMatch {

    export enum status {
        FULL_MATCH = 'FULL_MATCH',
        PARTIAL_MATCH = 'PARTIAL_MATCH',
        MANUAL_MATCH = 'MANUAL_MATCH',
    }


}

